import { Box, Button, Grid } from '@material-ui/core';
import Paper from "@material-ui/core/Paper";
import TableHead from "@material-ui/core/TableHead";
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { API_URL } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import './style.css';
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';

/*ページネーション*/
interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number,
  ) => void;
}
function TablePaginationActions(props: TablePaginationActionsProps) {

  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}
/*ページネーション*/

const Constructionlist: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()

  const [posts, setPosts] = useState<any[]>([])
  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
  useEffect(() => {
    openLoading()
    axios.post(API_URL.CHECKLIST_LIST,
      {
        "company_id": jsonlist.user.company_id,
      },
      { headers: { Authorization: jsonlist.token.IdToken } },

    )
      .then(res => {
        const persons = res.data.data;
        //console.log(persons)
        setPosts(persons)
      })
      .catch(error => {
        //let jsonObject = JSON.parse(error);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })
  }, []);


  /*ページネーション*/
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - posts.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  /*ページネーション*/

  return (

    <GenericTemplate title="チェックリスト">

      <Stack spacing={3} margin={4}></Stack>

      <Grid container spacing={3}>
        <Grid item sm={12} xs={12}>
          <Button
            className="btnlink"
            color="primary"
            variant="contained"
            size="large"
            component={Link}
            to="/CheckCreat"
          >
            ＋ チェックリスト新規作成
          </Button>
        </Grid>
      </Grid>

      <Stack spacing={3} margin={1}></Stack>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 500 }} className="table-list-style">
          <TableHead>
            <TableRow>
              <TableCell className="table-title">チェックリスト名</TableCell>
              <TableCell className="table-title">概要</TableCell>
              <TableCell className="table-title">更新日時</TableCell>
              <TableCell className="table-title">更新者</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="event_table">
            {(rowsPerPage > 0
              ? posts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : posts
            ).map((row, index) => (
              <TableRow key={index}>
                <TableCell className="MuiTableCell-root2"><Link to={{ pathname: "/CheckDatail", state: { check_id: row.checklist_group_id } }}>{row.checklist_name}</Link></TableCell>
                <TableCell className="MuiTableCell-root2"><Link to={{ pathname: "/CheckDatail", state: { check_id: row.checklist_group_id } }}>{row.checklist_memo}</Link></TableCell>
                <TableCell className="MuiTableCell-root2"><Link to={{ pathname: "/CheckDatail", state: { check_id: row.checklist_group_id } }}>{row.updated_at}</Link></TableCell>
                <TableCell className="MuiTableCell-root2"><Link to={{ pathname: "/CheckDatail", state: { check_id: row.checklist_group_id } }}>{row.updated_by}</Link></TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                labelRowsPerPage="表示件数:"
                rowsPerPageOptions={[
                  { label: '5件', value: 5 },
                  { label: '10件', value: 10 },
                  { label: '25件', value: 25 },
                  { label: '全て', value: -1 }
                ]}
                colSpan={4}
                count={posts.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                className="table-footer"
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      <Stack spacing={3} margin={1}></Stack>
    </GenericTemplate>
  );
};

export default Constructionlist;